export const flightSortTypeForConsultation: any = {
  recommended: "プロのおすすめ",
  duration: "移動時間短いフライト",
  price: "料金安いフライト",
};
